import { Flex, Image, keyframes } from "@chakra-ui/react";
import { fastamoniFrame } from "../../../../assets/exports";

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-100%); }
`;

const FastaMoni = () => {
  return (
    <Flex
      pt="103px"
      pb="152px"
      overflow="hidden"
      whiteSpace="nowrap"
      position="relative"
    >
      <Flex
        animation={`${scroll} 15s linear infinite`}
        display="inline-flex"
        minW="full"
        justifyContent="space-between"
      >
        <Image w={{ base: "370px", md: "unset" }} src={fastamoniFrame} />
        <Image w={{ base: "370px", md: "unset" }} src={fastamoniFrame} />
        <Image w={{ base: "370px", md: "unset" }} src={fastamoniFrame} />
        <Image w={{ base: "370px", md: "unset" }} src={fastamoniFrame} />
      </Flex>
    </Flex>
  );
};

export default FastaMoni;
